module.exports = __webpack_public_path__ + "img/Valid_Badge.4f9193d8.png";